// extracted by mini-css-extract-plugin
module.exports = {"block":"block-sm_block__PAZrO","link":"block-sm_link__Ferds","image":"block-sm_image__YIIeY","text":"block-sm_text__pTT4v"};